import React from 'react';
import { CheckIcon, CloudSunIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { Countdown } from './ui/Countdown';
import { checkoutUrl, price, priceBefore, productName, totalBonuses, totalVolumes } from '../data/offer';
const assurances = ['7-day guarantee', 'Secure payment', 'Instant access', 'Teach atmospheric science with confidence starting today'];
export function FinalCta() {
  return <section className="bg-stage water-glow py-16 sm:py-20" aria-labelledby="final-title" data-id="element-70" data-mp="1jbk9e684mx9p">
      <div className="mx-auto max-w-3xl px-4 text-center" data-id="element-71" data-mp="1ed8yds63igpw">
        <p className="inline-flex items-center gap-2 text-xs font-extrabold uppercase tracking-[.16em] text-silver" data-id="element-72" data-mp="1t2ojariy3rxo">
          <CloudSunIcon className="h-4 w-4" aria-hidden="true" data-id="element-73" data-mp="1o3lg7cmizvsc" /> {productName}
        </p>
        <h2 id="final-title" className="mx-auto mt-5 max-w-2xl text-balance text-3xl font-extrabold text-white sm:text-4xl" data-id="element-74" data-mp="22336jwfgzh3t">
          Created by meteorology specialists, for educators worldwide
        </h2>

        <Countdown className="mt-8" data-id="element-75" data-mp="n6dzj6dcrpoz" />

        <div className="mt-8 flex flex-col gap-5 rounded-xl border border-silver/40 bg-navyPanel p-6 text-left shadow-lift sm:flex-row sm:items-center sm:justify-between" data-id="element-76" data-mp="n7fhlussdcg7">
          <p data-id="element-77" data-mp="x2z9850bhoz5">
            <b className="block text-sm uppercase leading-tight text-silverBright" data-id="element-78" data-mp="x27esxighxag">{productName}</b>
            <span className="text-sm text-silver" data-id="element-79" data-mp="124g4nl018j8c">
              {totalVolumes} volumes + {totalBonuses} bonuses · Instant access
            </span>
          </p>
          <div className="sm:text-right" data-id="element-80" data-mp="1b2rw1p8q3l1u">
            <p className="text-sm text-silver" data-id="element-81" data-mp="1b1qlrmzj72l6">
              <span className="mr-2 line-through" data-id="element-82" data-mp="1ftqfuysx719u">{priceBefore}</span>
              <b className="text-base text-silverBright" data-id="element-83" data-mp="1fwmdsn4rppya">{price}</b>
            </p>
            <Button href={checkoutUrl} target="_blank" rel="noopener noreferrer" size="sm" className="mt-2" data-id="element-84" data-mp="1kvfqidc8dcxe">
              Get my teacher ready now
            </Button>
          </div>
        </div>

        <ul className="mt-8 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-silverDark" data-id="element-85" data-mp="1tryhvl4tcsrv">
          {assurances.map(item => <li key={item} className="inline-flex items-center gap-1.5" data-id="element-86" data-mp="3lwdncjstkj6n">
              <CheckIcon className="h-4 w-4 text-silver" aria-hidden="true" data-id="element-87" data-mp="3hl8pgbcmugu" /> {item}
            </li>)}
        </ul>
      </div>
    </section>;
}